export const matchesInsensitive = (text: string, phrase: string) =>
  text.toLowerCase().includes(phrase.toLowerCase());
